import type { ICellRendererParams } from 'ag-grid-community';
import { FC } from 'react';

export const BooleanCellRenderer: FC<ICellRendererParams<unknown, boolean>> = ({ value }) => {
  if (!value) {
    return null;
  }
  return <em className="icon icon-sm">check</em>;
};
